import type { Account, AccountTreeNode } from "@/types";

export function buildAccountTree(accounts: Account[]): AccountTreeNode[] {
  const nodeMap = new Map<string, AccountTreeNode>();

  for (const account of accounts) {
    nodeMap.set(account.path, {
      ...account,
      children: [],
      // depth = number of segments, e.g. "asset.cash.operating" → 3
      depth: account.path.split(".").length,
    });
  }

  const roots: AccountTreeNode[] = [];

  for (const node of nodeMap.values()) {
    const lastDot = node.path.lastIndexOf(".");
    if (lastDot === -1) {
      roots.push(node);
    } else {
      // Everything before the last dot is the parent's path
      // "asset.cash.operating" → parentPath = "asset.cash"
      const parentPath = node.path.slice(0, lastDot);
      const parent = nodeMap.get(parentPath);
      if (parent) {
        parent.children.push(node);
      } else {
        roots.push(node);
      }
    }
  }

  return roots;
}
